import { Component, Input } from '@angular/core';

@Component({
    selector: 'appc-page-heading',
    template: `<h4>{{text}}</h4>`
})
export class PageHeadingComponent {
    @Input() text: string;
    constructor() { }
}



// WEBPACK FOOTER //
// /Volumes/Projects/dev2/ng2fb-bootstrap/src/app/shared/directives/page-heading.ts